module.exports={
  "analytics_page": {
    "id": "analytics_page",
    "eventName": "analytics_page",
    "eventProduct": "analytics",
    "eventCategory": "Inicio de Análises",
    "eventAction": "Carregamento da página",
    "eventValue": 0
  }
}
